import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  card: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    overflow: 'hidden',
    backgroundColor: theme.palette.background.paper,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  thumbnail: {
    width: '100%',
    height: 180,
    transform: 'none',
  },
  body: {
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    gap: theme.spacing(1.5),
  },
  categories: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(0.5),
  },
  chip: {
    borderRadius: theme.shape.borderRadius,
    transform: 'none',
  },
  title: {
    fontSize: 14,
  },
  meta: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(2),
  },
  metaText: {
    fontSize: 12,
  },
  accessButton: {
    marginTop: 'auto',
    height: 36,
    borderRadius: theme.shape.borderRadius,
    transform: 'none',
  },
}))

export default useStyles
